import { render } from "./SSUrlSwitcher.vue?vue&type=template&id=f6199964"
import script from "./SSUrlSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SSUrlSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SSUrlSwitcher.vue?vue&type=style&index=0&id=f6199964&lang=scss"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/components/header-controls/SSUrlSwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6199964"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6199964', __exports__)) {
    api.reload('f6199964', __exports__)
  }
  
  module.hot.accept("./SSUrlSwitcher.vue?vue&type=template&id=f6199964", () => {
    api.rerender('f6199964', render)
  })

}


export default __exports__